var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 434,
    viewBox: "0 0 416 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3539)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6871 143.459L167.407 288.365L83.6871 433.239L0 288.365L83.6871 143.459Z",
    fill: "url(#paint0_linear_196_3539)",
    fillOpacity: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_196_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.156 0.758301H333.53L416 143.46L332.279 288.367H167.407L249.843 145.632L166.156 0.758301Z",
    fill: "url(#paint1_linear_196_3539)",
    fillOpacity: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_196_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6873 143.458L122.107 209.989L83.6873 276.487L45.2676 209.989L83.6873 143.458Z",
    fill: "url(#paint2_linear_196_3539)",
    fillOpacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_196_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.235 0L416 143.459L332.28 288.365L249.844 145.63L333.235 0Z",
    fill: "url(#paint3_linear_196_3539)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3539",
    x: -23,
    y: -23,
    width: 462,
    height: 479.239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3539",
    x: -20,
    y: 123.459,
    width: 207.407,
    height: 329.78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_196_3539",
    x: 146.156,
    y: -19.2417,
    width: 289.844,
    height: 327.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_196_3539",
    x: 25.2676,
    y: 123.458,
    width: 116.84,
    height: 173.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_196_3539",
    x: 229.844,
    y: -20,
    width: 206.156,
    height: 328.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3539",
    x1: 172.708,
    y1: 400.549,
    x2: -36.1962,
    y2: 366.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3539",
    x1: 423.911,
    y1: 255.922,
    x2: 121.895,
    y2: 182.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_3539",
    x1: 124.54,
    y1: 261.48,
    x2: 28.6529,
    y2: 245.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_196_3539",
    x1: 421.261,
    y1: 255.835,
    x2: 213.89,
    y2: 222.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge2);
export default __webpack_public_path__ + "static/media/bridge-2.dd133ca4b3147db6001e250736ec8543.svg";
export { ForwardRef as ReactComponent };